import { useState } from "react";
import { Input, Label, Table } from "reactstrap";
import { topSellingTableData } from "src/Data/Dashboard/EcommerceDashboard/EcommerceDashboard";
import { SearchTableButton } from "../../../../utils/Constant";

const TopSellingTable = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems = topSellingTableData.filter((item) => item.productName && item.productName.toLowerCase().includes(filterText.toLowerCase()));

  return (
    <div className='table-responsive dataTables_wrapper custom-scrollbar'>
      <div className='dataTables_filter'>
        <Label>{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type='search' value={filterText} />
      </div>
      <Table className='display' responsive id='slling-card'>
        <thead>
          <tr>
            <th className="checkbox-checked">
              <Input type='checkbox' />
            </th>
            <th>Product Name</th>
            <th>Client name</th>
            <th>Date</th>
            <th>Sold</th>
            <th>Earning</th>
          </tr>
        </thead>
        <tbody>
          {filteredItems.length > 0 ? (
            <>
              {filteredItems.map((item, index) => (
                <tr key={index}>
                  <td className="checkbox-checked">
                    <Input type='checkbox' />
                  </td>
                  <td>
                    <div className='d-flex gap-2'>
                      <div className='flex-shrink-0'>
                        <img src={item.productImage} alt='user' />
                      </div>
                      <div className='flex-grow-1'>
                        <a href='product.html'>
                          <h6 className='f-w-600'>{item.productName}</h6>
                          <span>{item.price}</span>
                        </a>
                      </div>
                      <div className='active-status active-online'></div>
                    </div>
                  </td>
                  <td>{item.clientName}</td>
                  <td>{item.date}</td>
                  <td>{item.sold}</td>
                  <td>
                    <span>{item.earning}</span>
                  </td>
                </tr>
              ))}
            </>
          ) : (
            <>
              <tr className='text-center'>
                <td colSpan={6}>
                  <h6>No matching records found</h6>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default TopSellingTable;
